export { IObjectWithKey, ISelection, SELECTION_CHANGE, SelectionDirection, SelectionMode } from '@uifabric/utilities';



// WEBPACK FOOTER //
// ../src/utilities/selection/interfaces.ts